import { PhoneNumber } from "../redux/reducers/dealPersonDetailsSlice";

export function isPipedriveDetailsContext(): boolean {
  const params = new URLSearchParams(window.location.search);
  const view = params.get("view");
  const resource = params.get("resource");
  return (
    view === "details" &&
    (resource === "deal" || resource === "person") &&
    !!params.get("selectedIds")
  );
}

/** Digits only for recipient search (strips +, spaces, and other symbols). */
export function normalizePhoneSearchQuery(phone: string): string {
  return String(phone).replace(/\D/g, "");
}

/** Match search query to a recipient phone (with or without country code). */
export function recipientMatchesSearchQuery(
  searchQuery: string,
  recipientPhone: string | number
): boolean {
  const queryDigits = normalizePhoneSearchQuery(searchQuery);
  const phoneDigits = normalizePhoneSearchQuery(String(recipientPhone));
  if (!queryDigits || !phoneDigits) return false;
  return (
    phoneDigits === queryDigits ||
    phoneDigits.endsWith(queryDigits) ||
    queryDigits.endsWith(phoneDigits)
  );
}

export function getPrimaryPhoneSearchQuery(
  phoneNumbers: PhoneNumber[]
): string | null {
  if (phoneNumbers.length === 0) return null;
  const phone = phoneNumbers.find((p) => p.primary) ?? phoneNumbers[0];
  const query = normalizePhoneSearchQuery(phone.value ?? "");
  return query || null;
}
